import styled from 'styled-components';

export const StyledEmailFirstMarketingOptInField = styled.div<{ justifyCenter: boolean; }>`
    display: flex;
    gap: 2rem;
    ${({ justifyCenter }) => (justifyCenter ? `justify-content: center;` : ``)}
`;
